// state/uploading-state.ts
export interface UploadingState {
  uploadedFiles: string[];
  uploadProgress: Record<string, number>;
  loading: boolean;
  hasError: boolean;
  project?: any;
}

const initialState: UploadingState = {
  uploadedFiles: [],
  uploadProgress: {},
  loading: false,
  hasError: false,
  project: undefined
};

// Action Types
const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
const SET_LOADING = "SET_LOADING";
const SET_ERROR = "SET_ERROR";
const CLEAR_UPLOADS = "CLEAR_UPLOADS";
const REMOVE_FILE = "REMOVE_FILE";

// Reducer
export default function uploadingReducer(
  state: UploadingState = initialState,
  action: any
): UploadingState {
  switch (action.type) {
    case "SET_UPLOAD_PROJECT":
      return { ...state, project: action.payload };
    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadedFiles: state.uploadedFiles.includes(action.payload.fileName)
          ? state.uploadedFiles
          : [...state.uploadedFiles, action.payload.fileName],
        uploadProgress: { ...state.uploadProgress, [action.payload.fileName]: action.payload.percent },
      };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_ERROR:
      return { ...state, hasError: action.payload };
    case CLEAR_UPLOADS:
      return { ...initialState };
    case REMOVE_FILE:
      const { [action.payload]: _, ...restProgress } = state.uploadProgress;
      return {
        ...state,
        uploadedFiles: state.uploadedFiles.filter((f) => f !== action.payload),
        uploadProgress: restProgress,
      };
    default:
      return state;
  }
}

// Action Creators
export const setUploadProgress = (payload: { fileName: string; percent: number }) => ({
  type: SET_UPLOAD_PROGRESS,
  payload,
});

export const setUploadProject = (project: any) => ({
  type: "SET_UPLOAD_PROJECT",
  payload: project,
});

export const setLoading = (payload: boolean) => ({ type: SET_LOADING, payload });
export const setError = (payload: boolean) => ({ type: SET_ERROR, payload });
export const clearUploads = () => ({ type: CLEAR_UPLOADS });
export const removeFile = (fileName: string) => ({ type: REMOVE_FILE, payload: fileName });
